/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import * as React from "react";
/**
 * Properties of the AbHSeparator component.
 */

/**
 * The **AbHSeparator** component is a simple horizontal separator.
 */
export const AbHSeparator = props => {
  return /*#__PURE__*/React.createElement("hr", ReactUtils.componentProps("ab-hseparator", props));
};
//# sourceMappingURL=AbHSeparator.js.map
